export default {
  data: {
    active: false,
    count: 0,
    total: 0,
    msg: '',
    postfix: 'học sinh'
  },
  start({ count, total, msg, postfix = 'học sinh' }) {
    Object.assign(this.data, { count, total, msg, active: true, postfix })
  },
  count(count) {
    Object.assign(this.data, { count: count })
  },
  end() {
    Object.assign(this.data, { active: false, count: 0, total: 0 })
  }
}
